import { render, staticRenderFns } from "./comp_Hook-ProductPage-DescriptionAndAttrs.vue?vue&type=template&id=48b74c93&scoped=true&"
import script from "./comp_Hook-ProductPage-DescriptionAndAttrs.vue?vue&type=script&lang=js&"
export * from "./comp_Hook-ProductPage-DescriptionAndAttrs.vue?vue&type=script&lang=js&"
import style0 from "./comp_Hook-ProductPage-DescriptionAndAttrs.vue?vue&type=style&index=0&id=48b74c93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b74c93",
  null
  
)

export default component.exports